import type { GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'insur_growth_starter',
    industryId: 'insurtech',
    tier: 1,
    name: 'Policy Core',
    description: 'Foundational insurance compliance missions.',
    unlocks: {
      missionIds: ['insur_mission_compliance'],
      productIds: ['insur_auto'],
    },
  },
  {
    id: 'insur_growth_claims',
    industryId: 'insurtech',
    tier: 2,
    name: 'Claims Operations',
    description: 'Claims processing after compliance setup.',
    unlockConditions: { completedMissionIds: ['insur_mission_compliance'] },
    unlocks: {
      missionIds: ['insur_mission_fraud'],
      productIds: ['insur_claims', 'insur_health'],
    },
  },
  {
    id: 'insur_growth_underwriting',
    industryId: 'insurtech',
    tier: 3,
    name: 'Smart Underwriting',
    description: 'AI-driven pricing after fraud detection mastery.',
    unlockConditions: { completedMissionIds: ['insur_mission_fraud'], minCompliance: 65 },
    unlocks: {
      productIds: ['insur_underwriting'],
    },
  },
];

export const insurtechPack = buildPack({
  id: 'insurtech',
  ...PACK_CONTENT.insurtech,
  growthPacks,
  expansionPacks: [
    {
      id: 'insur_exp_reinsurance',
      industryId: 'insurtech',
      name: 'Reinsurance Analytics',
      version: '1.0.0',
      description: 'Adds ISO 27001 and SOC 2 framework focus for carrier partnerships.',
      requiresGrowthTierId: 'insur_growth_underwriting',
      // Framework ids added when insurtech entries land in REGULATORY_FRAMEWORKS
      adds: {},
    },
  ],
});